module.exports = "../../../../platform/assets/pageMainIcon/icon-shuzhi-4-green.svg";